// Modules
import { Action, createReducer, on } from '@ngrx/store';

// Interfaces
import { IUser } from '@shared/interfaces/users';

// Actions
import * as ViewProfileActions from '@store/actions/view-profile.actions';

export interface ViewProfileState {
  user: IUser;
  loadingViewProfile: boolean;
}

export const initialViewProfileState: ViewProfileState = {
  user: undefined,
  loadingViewProfile: false,
};

const ViewProfileReducer = createReducer(
  initialViewProfileState,
  on(ViewProfileActions.reset, () => initialViewProfileState),
  on(ViewProfileActions.getUserProfileResponse, (state, action) => ({
    ...state,
    loadingViewProfile: false,
    user: action.payload,
  })),
  on(ViewProfileActions.getUserProfileRequested, state => ({
    ...state,
    loadingViewProfile: true,
  }))
);

export function reducer(
  state: ViewProfileState | undefined,
  action: Action
): ViewProfileState {
  return ViewProfileReducer(state, action);
}
